import script from "./ticketCommons.vue?vue&type=script&lang=js"
export * from "./ticketCommons.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__